import { useContext } from "react";
import { VehicleContext } from "../providers";

/**
 * Hook that returns the vehicle context value
 * 
 * @returns The vehicle context
 */
const useVehicle = () => {
  const vehicleContext = useContext(VehicleContext);

  if (!vehicleContext) {
    throw new Error("useVehicle must be used within an VehicleProvider");
  }
  return vehicleContext;
};

export default useVehicle;
